import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  // Setting a new Cookie
  setCookie(name: string, value: any, days: number): void {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    if (isPlatformBrowser(this.platformId)) {
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  }

  // Getting a cookie
  getCookie(name: string): string | null {
    // console.log(name);
    var nameEQ = name + "=";
    if (isPlatformBrowser(this.platformId)) {
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
    return null;
  }

  delete_cookie(name: string) {
    if (isPlatformBrowser(this.platformId)) {
      document.cookie =
        name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    }
  }
}
